import * as Sentry from "@sentry/react";
import { PostgrestError } from "@supabase/supabase-js";

export function handleSupabaseError(
  error: PostgrestError | Error,
  operation: string,
  context?: Record<string, any>
) {
  // Adicionar breadcrumb
  Sentry.addBreadcrumb({
    category: 'supabase',
    message: `Supabase ${operation} failed`,
    level: 'error',
    data: {
      operation,
      ...context,
    },
  });

  // Capturar erro com contexto
  Sentry.captureException(error, {
    tags: {
      service: 'supabase',
      operation,
    },
    extra: {
      ...context,
      errorDetails: 'details' in error ? error.details : undefined,
      errorHint: 'hint' in error ? error.hint : undefined,
      errorCode: 'code' in error ? error.code : undefined,
    },
  });
}
